import { Component, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { SendMailModel } from '../Models/Common/SendMailModel';
import { ContactUsParams } from '../Models/Request/ContactUsParams';
import { ContactUsService } from '../services/ContactUsService.service';
import { SendMailStepEnum } from '../enums/SendMailStepEnum';


@Component({
  selector: 'app-have-questions-form',
  templateUrl: './have-questions-form.component.html',
  styleUrls: ['./have-questions-form.component.css']
})
export class HaveQuestionsFormComponent implements OnInit {
  ContactUsForm: FormGroup;
  SendMailMessage: string;
  SendMailStep: SendMailStepEnum;
  SendMailStepEnumType = SendMailStepEnum;
  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private contactUsService: ContactUsService
  ) {
    this.SendMailStep = SendMailStepEnum.None;
    this.ContactUsForm = new FormGroup({
      Intro: new FormControl('', Validators.required),
      FullName: new FormControl('', Validators.required),
      PhoneNumber: new FormControl('',[Validators.pattern('[- +()0-9]{6,20}')]),
      Email: new FormControl('',[Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]+\\.[a-z]{2,4}$')]),
      Subject: new FormControl('', Validators.required),
      Message: new FormControl('', Validators.required)
    });
  }

  async SubmitForm() {
    if (this.ContactUsForm.valid) {
      this.SendMailMessage = "";
      var token = await this.recaptchaV3Service.execute('importantAction').toPromise<string>();
      if (token) {
        this.SendMailStep = SendMailStepEnum.Request;
        var MailObj: SendMailModel = {
          Intro: this.ContactUsForm.value.Intro.replace('.',''),
          FullName: this.ContactUsForm.value.FullName,
          PhoneNumber: this.ContactUsForm.value.PhoneNumber,
          Email: this.ContactUsForm.value.Email,
          Subject: this.ContactUsForm.value.Subject,
          Message: this.ContactUsForm.value.Message
        };
        var RequestObj: ContactUsParams = {
          SendMailModel: MailObj,
          Token: token
        };
        console.log(JSON.stringify(RequestObj));
        var Responce = await this.contactUsService.SendMessage(RequestObj);
        if (!Responce.IsSuccessfull) {
          this.SendMailMessage = Responce.Message;
          this.HideMessage(1000);
        }
        else
        {
          this.SendMailMessage = "";
          this.ContactUsForm.reset();
          this.SendMailStep = SendMailStepEnum.Responce;
          this.HideMessage(5000);
        }
      }
      else
        this.SendMailMessage = 'Something went wrong with Captcha. We are working on resolving this issue. Please try again later.';
    }
    else
      this.SendMailMessage = 'Please enter all required fields';
  }

  async HideMessage(time:number) {
    await new Promise( resolve => setTimeout(resolve, time) );
    this.SendMailStep = SendMailStepEnum.None;
  }

  ngOnInit(): void {
  }

}
